/**
 * Alias validation utility
 * Shared validation logic for address aliases
 */

// Maximum alias length
export const ALIAS_MAX_LENGTH = 32;

// Description text for UI display
export const ALIAS_DESCRIPTION = 'Alias max 32 characters.';

/**
 * Validate an alias string
 * @param {string} alias - The alias to validate
 * @returns {{ valid: boolean, error: string | null }} Validation result
 */
export const validateAlias = (alias) => {
  if (!alias) {
    return { valid: false, error: 'Alias cannot be empty' };
  }

  const trimmed = alias.trim();

  if (trimmed.length === 0) {
    return { valid: false, error: 'Alias cannot be empty' };
  }

  if (trimmed.length > ALIAS_MAX_LENGTH) {
    return { valid: false, error: `Alias must be ${ALIAS_MAX_LENGTH} characters or less` };
  }

  return { valid: true, error: null };
};
